import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"
import { payrollRunStateV1Schema } from "./payroll-run-v1.js"

export const payrollRunPollV1Schema = z
  .object({ runId: entityIdSchema })
  .strict()

export const payrollProviderObservationDispositionV1Schema = z.enum([
  "applied",
  "ignored",
  "duplicate",
  "reconciliation_required",
])

export const payrollProviderWebhookResultV1Schema = z
  .object({
    resultVersion: z.literal(1),
    status: payrollProviderObservationDispositionV1Schema,
    eventRef: z.string().regex(/^[a-f0-9]{16}$/),
    runId: entityIdSchema.nullable(),
    runState: payrollRunStateV1Schema.nullable(),
  })
  .strict()

export const payrollRunPollResultV1Schema = z
  .object({
    entityType: z.literal("payroll_run"),
    entityId: entityIdSchema,
    state: payrollRunStateV1Schema,
    version: z.number().int().positive(),
    providerState: z.enum(["accepted", "processing", "succeeded", "failed"]),
    observationStatus: payrollProviderObservationDispositionV1Schema,
    providerOperationMatched: z.boolean(),
  })
  .strict()

export type PayrollProviderWebhookResultV1 = z.infer<
  typeof payrollProviderWebhookResultV1Schema
>
export type PayrollRunPollResultV1 = z.infer<
  typeof payrollRunPollResultV1Schema
>
